<template>
  <div>
    <div class="uiBreadcrumb">
      <ul class="uiClrfix" v-if="lang == 'chs'">
        <li>
          <a href="./"> <svg-icon icon-class="home-filling" />首页</a>
        </li>
        <li><span>/</span><a class="cur">隐私声明</a></li>
      </ul>
      <ul class="uiClrfix" v-else>
        <li>
          <a href="./"> <svg-icon icon-class="home-filling" />Home</a>
        </li>
        <li><span>/</span><a class="cur">Privacy Policy</a></li>
      </ul>
    </div>
    <div class="center">
      <div class="about_main" v-if="lang == 'chs'">
        <h3 class="about_main_title">{{ mianText.title }}</h3>
      </div>
      <div class="about_main" v-else>
        <h3 class="about_main_title">{{ mianText.titleE }}</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PrivacyPolicy",
  data() {
    return {
      lang: "",
      mianText: {
        title: "隐私声明",
        titleE: "Privacy Policy",
      }
    };
  },
  methods: {
  },
  mounted() {
    let lang = sessionStorage.getItem("lang");
    if (lang) {
      this.lang = lang;
      this.$store.commit("setLang", lang);
    } else {
      this.lang = "chs";
      this.$store.commit("setLang", "chs");
    }
  },
  computed: {
    listenData() {
      return this.$store.state.lang;
    },
  },
  watch: {
    listenData(newVal) {
      this.lang = newVal;
    },
  },
};
</script>

<style scoped>
@media print {
  .hidden {
    display: none;
  }
}
.uiBreadcrumb {
  width: 1200px;
  padding: 0 15px;
  margin: 15px auto;
  height: 19px;
}

.uiBreadcrumb ul li {
  float: left;
}

.uiBreadcrumb ul li:nth-child(1):hover a {
  color: #233a78;
}

.uiBreadcrumb ul li span {
  padding: 0 5px;
}

.uiBreadcrumb ul li a {
  color: #999;
  font-size: 14px;
}

.uiBreadcrumb ul li .cur {
  color: #333;
  font-size: 14px;
}
.center {
  width: 1200px;
  margin: auto;
  background: #fff;
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}
.about_main {
  margin-top: 30px;
  min-height: 260px;
  line-height: 27px;
  padding: 60px 230px 90px;
  font-size: 18px;
}
.about_main_title {
  padding: 20px 0 30px;
}
</style>